import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'investment-amount-duration-form',
  templateUrl: './investment-amount-duration-form.component.html',
  styleUrls: ['./investment-amount-duration-form.component.scss'],
  standalone: false,
})
export class InvestmentAmountDurationFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
